<template>
  <span :class="`${colorClass} whitespace-nowrap`">
    {{ formattedValue }}
  </span>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    value: string | number | null
    withPercentage?: boolean
    hasArrow?: boolean
  }>(),
  { hasArrow: false, withPercentage: false },
)

const trimmedConvertedValue = computed(() => String(props.value).trim())

const isValueNegative = computed(() => trimmedConvertedValue.value[0] === '-')

const colorClass = computed(() =>
  isValueNegative.value ? 'text-static-danger-hi' : 'text-static-success-hi',
)

const formattedValue = computed(() => {
  if (!trimmedConvertedValue.value || !props.hasArrow) return props.value

  const arrow = isValueNegative.value ? '↓' : '↑'

  if (props.withPercentage) {
    return `${arrow} ${props.value}%`
  }

  return `${arrow} ${props.value}`
})
</script>
